@file:OptIn(InternalResourceApi::class)

package ischoolconnect.sharedui.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/ischoolconnect.sharedui.generated.resources/"

@delegate:ResourceContentHash(-200_505_136)
internal val Res.font.IndieFlower_Regular: FontResource by lazy {
      FontResource("font:IndieFlower_Regular", setOf(
        ResourceItem(setOf(), "${MD}font/IndieFlower-Regular.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_424_466_421)
internal val Res.font.inter_bold: FontResource by lazy {
      FontResource("font:inter_bold", setOf(
        ResourceItem(setOf(), "${MD}font/inter_bold.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(186_884_475)
internal val Res.font.inter_light: FontResource by lazy {
      FontResource("font:inter_light", setOf(
        ResourceItem(setOf(), "${MD}font/inter_light.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_061_454_729)
internal val Res.font.inter_medium: FontResource by lazy {
      FontResource("font:inter_medium", setOf(
        ResourceItem(setOf(), "${MD}font/inter_medium.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_619_971_345)
internal val Res.font.inter_regular: FontResource by lazy {
      FontResource("font:inter_regular", setOf(
        ResourceItem(setOf(), "${MD}font/inter_regular.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_898_574_751)
internal val Res.font.inter_semibold: FontResource by lazy {
      FontResource("font:inter_semibold", setOf(
        ResourceItem(setOf(), "${MD}font/inter_semibold.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(614_057_015)
internal val Res.font.playfair_display_italic: FontResource by lazy {
      FontResource("font:playfair_display_italic", setOf(
        ResourceItem(setOf(), "${MD}font/playfair_display_italic.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("IndieFlower_Regular", Res.font.IndieFlower_Regular)
  map.put("inter_bold", Res.font.inter_bold)
  map.put("inter_light", Res.font.inter_light)
  map.put("inter_medium", Res.font.inter_medium)
  map.put("inter_regular", Res.font.inter_regular)
  map.put("inter_semibold", Res.font.inter_semibold)
  map.put("playfair_display_italic", Res.font.playfair_display_italic)
}
